import styled from 'styled-components';
import LoadingGif from '@assets/images/shared/loading.gif';

export const Loader = styled.div`
  width: 100%;
  min-height: 200px;
  background: url(${LoadingGif}) no-repeat center;
  background-size: 32px;
`;
